import { Badge, Box, Tab, Tabs } from "@mui/material";
import { IOperadorConectado } from "../../../interface/atendimento/websocket/IOperadorConectado";

interface AbasOperadoresProps {
    operadores: IOperadorConectado[];
    operadorUuidAtual: string | null;
    abaAtiva: string;
    onChange: (aba: string) => void;
    /** Contagem de chats por aba — chave 'TODOS' ou operadorUuid */
    contagens: Record<string, number>;
}

/**
 * Barra de abas exibida quando há 2+ operadores conectados no mesmo estabelecimento.
 * Permite filtrar a lista de chats por: TODOS (sem dono) ou por operador.
 */
export const AbasOperadores: React.FC<AbasOperadoresProps> = ({
    operadores,
    operadorUuidAtual,
    abaAtiva,
    onChange,
    contagens,
}) => {
    const renderLabel = (texto: string, chave: string) => {
        const total = contagens[chave] ?? 0;
        return (
            <Badge
                badgeContent={total}
                color="primary"
                max={99}
                sx={{ '& .MuiBadge-badge': { right: -10, top: 2 } }}
            >
                <span>{texto}</span>
            </Badge>
        );
    };

    return (
        <Box sx={{ width: '100%', borderBottom: 1, borderColor: 'divider' }}>
            <Tabs
                value={abaAtiva}
                onChange={(_, valor) => onChange(valor)}
                variant="scrollable"
                scrollButtons="auto"
                sx={{ minHeight: 40, '& .MuiTab-root': { minHeight: 40, textTransform: 'none', fontSize: '0.78rem', px: 1.5 } }}
            >
                <Tab value="TODOS" label={renderLabel('TODOS', 'TODOS')} />
                {operadores.map((op) => (
                    <Tab
                        key={op.operadorUuid}
                        value={op.operadorUuid}
                        label={renderLabel(
                            op.operadorUuid === operadorUuidAtual ? 'Você' : op.nome,
                            op.operadorUuid,
                        )}
                    />
                ))}
            </Tabs>
        </Box>
    );
};
